// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brand-shop-filter-tabs[data-v-cc2d2c50]{z-index:1;position:sticky;top:0;left:0}", ""]);
// Exports
module.exports = exports;
